import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const { supabase } = useAuth(); 
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    
    const processSupabaseAuth = async () => {
      try {
        // Supabase client automatically processes the URL hash on load.
        // We just need to verify the session was established.
        const { data: { session }, error: sessionError } = await supabase.auth.getSession();
        
        if (sessionError) throw sessionError;
        if (!session) { 
          navigate("/login"); 
          return; 
        }
        
        // Clear the messy token hash from the URL so it looks clean
        window.history.replaceState(null, "", window.location.pathname);
        
        // Redirect to dashboard
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setError("Google sign-in failed. Please try again.");
        setTimeout(() => navigate("/login"), 1500);
      }
    };

    processSupabaseAuth();
  }, [supabase, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background grain">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary mx-auto" />
        <p className="text-zinc-400 mt-4 text-sm">{error || "Signing you in…"}</p>
      </div>
    </div>
  );
}
